export enum ADDRESS_DELIVERY_TYPE {
 ALTERNATIVE_ADDRESS = 3,
 ALTERNATIVE_ADDRESS2 = 5, 
 BILLING_ADDRESS = 6,
 COF_ADDRESS = 4,
 DELIVERY_ADDRESS = 1,
 MAILING_ADDRESS = 2,
 NOT_INFORMED = 99,
}